import React, { Component } from "react"
import { connect } from "react-redux"
import { bindActionCreators, compose } from "redux"

import { loginGoogle, signUpGoogle } from "store/auth/action"
import { AUTH_TYPES } from "constants/auth-types"
import { GOOGLE_APP_KEY } from "constants/config"
import { GoogleLogin } from "react-google-login"
class GoogleButton extends Component {
  responseGoogle = (response) => {
    if (response) {
      const {
        school: { schoolData },
        type,
        signUpGoogle,
        loginGoogle,
      } = this.props
      const data = {
        id_token: response?.tokenId,
      }
      if (type === AUTH_TYPES.REGISTER) {
        data.role = "ST"
        data.school_id = schoolData?.id
        console.log(data, "register")
        signUpGoogle(data)
      } else {
        loginGoogle(data)
      }
    }
  }

  responseGoogleFailed = (response) => {
    console.log("fail", response)
  }

  render() {
    const { type } = this.props
    return (
      <GoogleLogin
        clientId={GOOGLE_APP_KEY}
        render={(renderProps) => (
          <button
            className="google"
            onClick={renderProps.onClick}
            disabled={renderProps.disabled}
          >
            {type === AUTH_TYPES.REGISTER
              ? "Continue with Google"
              : "Login with Google"}
          </button>
        )}
        onSuccess={this.responseGoogle}
        onFailure={this.responseGoogleFailed}
        cookiePolicy={"single_host_origin"}
      />
    )
  }
}

const mapStateToProps = (state) => ({
  school: state.schoolReducer,
})

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loginGoogle,
      signUpGoogle,
    },
    dispatch
  )

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  GoogleButton
)
